module.exports = __webpack_public_path__ + "img/link_web.cd035517.png";